module.exports = (__webpack_require__(2))(477);


//////////////////
// WEBPACK FOOTER
// delegated ../node_modules/core-js/modules/es6.array.join.js from dll-reference vendor_dll
// module id = 271
// module chunks = 0